import React, { createContext, useState, useEffect, useContext } from 'react';
import axios from 'axios';
import { AuthContext } from '../App';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const FestivalContext = createContext();

export const FestivalProvider = ({ children }) => {
  const { token, user } = useContext(AuthContext);
  const [selectedFestival, setSelectedFestival] = useState(null);
  const [allFestivals, setAllFestivals] = useState([]);
  const [loading, setLoading] = useState(true);

  // Fetch all festivals
  const fetchFestivals = async () => {
    if (!token) return;
    
    try {
      const response = await axios.get(`${API}/festivals`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setAllFestivals(response.data);
      
      // Set the active festival as selected by default
      const activeFestival = response.data.find(f => f.is_active);
      if (activeFestival) {
        setSelectedFestival(activeFestival);
      } else if (response.data.length > 0) {
        // If no active festival, select the first one
        setSelectedFestival(response.data[0]);
      }
    } catch (error) {
      console.error('Failed to fetch festivals:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchFestivals();
  }, [token]);

  // Categorize festivals based on dates
  const categorizeFestivals = () => {
    const now = new Date();
    
    const prior = [];
    const active = [];
    const upcoming = [];
    
    allFestivals.forEach(festival => {
      const startDate = new Date(festival.start_date);
      const endDate = new Date(festival.end_date);
      
      if (endDate < now) {
        prior.push(festival);
      } else if (startDate <= now && endDate >= now) {
        active.push(festival);
      } else {
        upcoming.push(festival);
      }
    });
    
    return { prior, active, upcoming };
  };

  const selectFestival = (festival) => {
    setSelectedFestival(festival);
    // Store in localStorage for persistence
    localStorage.setItem('selectedFestivalId', festival.id);
  };

  // Load selected festival from localStorage on mount
  useEffect(() => {
    const savedFestivalId = localStorage.getItem('selectedFestivalId');
    if (savedFestivalId && allFestivals.length > 0) {
      const festival = allFestivals.find(f => f.id === savedFestivalId);
      if (festival) {
        setSelectedFestival(festival);
      }
    }
  }, [allFestivals]);

  const value = {
    selectedFestival,
    setSelectedFestival: selectFestival,
    allFestivals,
    categorizeFestivals,
    loading,
    refreshFestivals: fetchFestivals
  };

  return (
    <FestivalContext.Provider value={value}>
      {children}
    </FestivalContext.Provider>
  );
};
